import { CaseRunCalculateDetailModel, CaseRunTaskModel } from "@app/api2/api";
import { BPBoxWithHeader } from "@common/BPBoxWithHeader";
import { BPDataTable3 } from "../../Common/DataTable/BPDataTable3";
import { BPColumn } from "@common/BPReactTable";
import { InfoBox } from "@common/InfoBox";
import { elapsedSecToString, toLocalTime } from "@common/Utils";
import { ParametersView } from "../ParametersView";
import { HandlerRegistry } from "../RunTypes/HandlerRegistry";

interface ICalculationDetailsProps {
    model: CaseRunCalculateDetailModel;
    forPrint?: boolean;
}

export function CalculationDetails(props: ICalculationDetailsProps) {
    const t = window.translation;

    return <>
        <InfoBox
            forPrint={props.forPrint}
            header={t.common.information}
            items={[
                { label: t.caseRunView.calculationType, description: t.runType[props.model.type], width: 6 },
                { label: t.common.case, description: props.model.caseName },
                { label: t.common.owner, description: props.model.createdBy, title: props.model.createdBy },
            ]} />

        <ParametersView
            forPrint={props.forPrint}
            model={props.model}
            parameters={(props.model.parameters ?? [])} parameterRenderer={props.model ? HandlerRegistry.getRunTypeHandler(props.model.type) : null}
        ></ParametersView>
        {!props.forPrint &&
            <BPBoxWithHeader forPrint={props.forPrint} header={t.caseRunView.calculationTasks}>
                <BPDataTable3
                    forPrint={props.forPrint}
                    simple
                    dataSource={(params) => {
                        return Promise.resolve({ items: props.model.tasks, totalRows: 0 });
                    }}
                    columns={[
                        { Header: t.caseRunView.step, accessor: 'phase', Cell: cell => t.jobPhase[cell.value] ?? '' },
                        { Header: t.common.created, accessor: 'started', Cell: cell => toLocalTime(cell.value) ?? '' },
                        { Header: t.common.completed, accessor: 'completed', Cell: cell => toLocalTime(cell.value) ?? '' },
                        { Header: t.caseRunView.timeUsed, accessor: 'timeTakenSeconds', Cell: cell => elapsedSecToString(cell.value) ?? '' },
                    ] as Array<BPColumn<CaseRunTaskModel>>} />
            </BPBoxWithHeader>
        }

    </>;
}
